// Toast.ts
import Toastify from "toastify-js";

export const showToast = (id: string) => {
    const el = document.querySelector(`#${id}`)?.cloneNode(true) as HTMLElement;

    if (!el) return;

    el.classList.remove("hidden");

    Toastify({
        node: el,
        duration: 1500,
        newWindow: true,
        close: true,
        gravity: "bottom",
        position: "left",
        stopOnFocus: true,
    }).showToast();
};
